import axios from 'axios'
import { store } from 'app/store'

const baseURL = `${process.env.REACT_APP_API_SERVER}/v1`
export const axiosClient = () => {
  const token = store.getState().authentications.token || undefined
  return axios.create({
    baseURL,
    headers: {
      'X-Auth-Token': token,
      'Content-Type': 'application/json',
    },
  })
}
